export default __webpack_public_path__ + "assets/images/6fdb72f5c450c1cb5bf1e2254afaa758.png";